import { store } from "../../_Bootstrap/RoutingAndStore";
import { SALE_RETRIEVE } from "../../Actions/SellScreen/SellScreenConstants";
import { freshSale } from "../../Reducers/SellScreen/SellScreenSaleReducer";
import { getOption } from "../../Utilities/Platform/Options/Options";
import BaseAgent, { generateWorkerURL } from "../Bases/BaseAgent";
import { AGENT_EVENTS, TAB_EVENT, TAB_EVENTS } from "./TabEvents";

const LOCATION_AVAILABLE =
    typeof window !== "undefined" &&
    typeof window.location !== "undefined" &&
    typeof window.location.pathname !== "undefined";

export default class TabAgent extends BaseAgent {
    protected enabled: boolean;

    constructor() {
        super(generateWorkerURL("tabworker"), "Shopfront Tab Checker");

        // Bind handlers
        this.handleTabEvents = this.handleTabEvents.bind(this);

        // Start the worker
        this.startWorker();

        this.enabled = true;

        // Listen for tab events
        if(typeof document !== "undefined") {
            document.addEventListener(TAB_EVENT, this.handleTabEvents);
        }
    }

    protected handleTabEvents(e: CustomEvent): void {
        if(!e.detail.type) {
            console.error("Unknown event sent to TabAgent", e);

            return;
        }

        if(e.detail.type === AGENT_EVENTS.DISABLE_RESPONSE) {
            this.enabled = false;

            return;
        } else if(e.detail.type === AGENT_EVENTS.ENABLE_RESPONSE) {
            this.enabled = true;

            return;
        }

        this.sendMessage(e.detail.type, e.detail.data, e.detail.success);
    }

    protected handleRefreshSale(): void {
        let sale = getOption("current_sale");

        if(sale === null) {
            console.log("Received sale refresh from the tab worker, there is no current sale");
            sale = freshSale();
        } else {
            console.log("Received sale refresh from the tab worker, there is a sale");
        }

        store.dispatch({
            type : SALE_RETRIEVE,
            state: sale,
        });
    }

    protected handleMessage(data: {
        type: TAB_EVENTS;
        message?: any;
    }): void {
        if(!data.type) {
            console.error("Unknown data passed to TabAgent", data);

            return;
        }

        switch(data.type) {
            case TAB_EVENTS.REQUEST_PAGE:
                if(LOCATION_AVAILABLE && this.enabled) {
                    this.sendMessage(AGENT_EVENTS.PAGE_RESPONSE, {
                        id  : data.message,
                        page: window.location.pathname,
                    });
                }

                break;
            case TAB_EVENTS.PING_PAGE:
                if(LOCATION_AVAILABLE && this.enabled) {
                    if(window.location.pathname === data.message.page) {
                        const notification = new Notification(data.message.message);

                        notification.onclick = (): void => {
                            parent.focus();
                            window.focus();
                        };
                    }
                }

                break;
            case TAB_EVENTS.REFRESH_SALE:
                this.handleRefreshSale();
                break;
            default:
                console.error("Unknown data passed to TabAgent", data);
        }
    }
}
